<template>
    <v-flex xs12 sm12 d-flex class="pt-0">
        <v-data-table v-if="documentos.length > 0"
                      :headers="colunasTabela" :items="documentos"
                      :loading="false" hide-actions class="az-table-list">
            <template v-slot:headers="props">
                <tr>
                    <th :style="{ width: '50px', padding: '0 !important' }">
                        <v-tooltip top>
                            <v-checkbox class="single-checkbox" slot="activator"
                                        :input-value="selecionouTodosDocs"
                                        :indeterminate="selecionouAlgumDoc && !selecionouTodosDocs"
                                        :disabled="desabilitaDocumentosSemIdVirtualizadoETodosAssinados"
                                        hide-details color="light-blue darken-2"
                                        @click.stop="selecionarTodosDocs"/>
                            <span v-show="!selecionouTodosDocs">Selecionar todos</span>
                            <span v-show="selecionouTodosDocs">Remover seleção</span>
                        </v-tooltip>
                    </th>
                    <th v-for="header in props.headers" :key="header.text" :align="header.align"
                        :style="`${header.width ? 'width: ' + header.width : ''}`">
                        <strong>{{ header.text }}</strong>
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr class="linhas-tabela-docs" :id="props.item.idVirtualizado">
                    <td style="padding: 0 !important;">
                        <v-checkbox primary hide-details
                                    color="light-blue darken-2" class="single-checkbox"
                                    :disabled="!props.item.idVirtualizado || props.item.documentoVirtualizadoAssinado"
                                    :input-value="foiSelecionado(props.item.idVirtualizado)"
                                    @click.stop="selecionarDoc(props.item.idVirtualizado)"/>
                    </td>
                    <td class="td-align">
                        <span>{{ props.item.dataCriacao | az-date('DD/MM/YYYY HH:mm') }}</span>
                    </td>
                    <td class="td-align">{{ props.item.descricao }}</td>
                    <td class="table-actions">
                        <div>
                            <a :href="criarLinkDownload(props.item.anexoUri)" target="_blank"
                               class="az-action-link-icon">
                                <v-icon>get_app</v-icon>
                            </a>
                            <a @click.prevent="confirmarRemocao(props.item.id)"
                               v-if="!isPropostaEnviada && props.item.tipoDocumento != 'ACEITE_TERMOS'">
                                <v-icon>close</v-icon>
                            </a>
                            <v-tooltip top v-if="props.item.documentoVirtualizadoAssinado">
                              <a slot="activator">
                                <v-icon color="green">
                                  check_circle
                                </v-icon>
                              </a>
                              Documento Assinado
                            </v-tooltip>

                            <v-tooltip top v-if="!props.item.idVirtualizado">
                              <a slot="activator">
                                <v-icon color="red">
                                  cancel
                                </v-icon>
                              </a>
                              Documento Não Virtualizado
                            </v-tooltip>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <az-ops v-if="!documentos.length > 0"
                title=""
                :message="`Não foram anexados documentos de ${categoriaDocumento}.`"/>
    </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento.vue";

export default {
    name: 'LicitacaoFornecedorDocumentosTabela',
  components: {IconeAssinarDocumento},
    props: {
        documentos: {
            type: Array,
            required: true,
            default: () => []
        },
        categoriaDocumento: {
            type: String,
            required: true,
            default: ''
        },
    },
    data() {
        return {
            colunasTabela: [
                {
                    text: 'Data',
                    align: 'left',
                    sortable: false,
                    width: '15%'
                },
                {
                    text: 'Nome',
                    sortable: false,
                    align: 'left',
                    width: '70%'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '15%'
                }
            ],
            selecionados: []
        }
    },
    computed: {
        desabilitaDocumentosSemIdVirtualizadoETodosAssinados() {
            return !this.documentos.some(doc => (doc.idVirtualizado !== undefined && doc.idVirtualizado !== null)
                || (doc.documentoVirtualizadoAssinado !== true));
        },
        isPropostaEnviada() {
            return this.propostaResumo.enviada
        },
        selecionouTodosDocs() {
            const idsComIdVirtualizado = this.documentos
                .filter(doc => doc.idVirtualizado && !doc.documentoVirtualizadoAssinado)
                .map(doc => doc.idVirtualizado);
            return idsComIdVirtualizado.length > 0 && idsComIdVirtualizado.length === this.selecionados.length;
        },
        selecionouAlgumDoc() {
            return this.selecionados.length > 0
        },
        ...mapState(['propostaResumo'])
    },
    methods: {
        confirmarRemocao(idDocumento) {
            this.$emit('confirmar-remocao', idDocumento)
        },
        foiSelecionado(id) {
            return this.selecionados.includes(id)
        },
        selecionarDoc(idCheckbox) {
            if (this.foiSelecionado(idCheckbox)) {
                this.selecionados = this.selecionados.filter(id => id !== idCheckbox)
            } else {
                this.selecionados.push(idCheckbox)
            }
        },
        selecionarTodosDocs() {
            const idsComIdVirtualizado = this.documentos
                .filter(doc => doc.idVirtualizado && !doc.documentoVirtualizadoAssinado)
                .map(doc => doc.idVirtualizado);

            if (this.selecionouTodosDocs) {
                this.selecionados = [];
            } else {
                this.selecionados = idsComIdVirtualizado;
            }
        },
        limparSelecao() {
            this.selecionados = []
        }
    }
}
</script>
<style lang="stylus">
.td-align
    padding-left: 12px !important

.single-checkbox
    .v-input__slot
        border 0 !important

.linhas-tabela-docs
    scroll-margin-top: 100px;

</style>